import { render, staticRenderFns } from "./updatePolicyModal.vue?vue&type=template&id=7360d19b&scoped=true"
import script from "./updatePolicyModal.vue?vue&type=script&lang=js"
export * from "./updatePolicyModal.vue?vue&type=script&lang=js"
import style0 from "./updatePolicyModal.vue?vue&type=style&index=0&id=7360d19b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7360d19b",
  null
  
)

export default component.exports